import $ from 'jquery';
import slick from 'slick-carousel';

const initCommonCarousel = ($carousel) => {
  $carousel.slick({
    dots: true,
    adaptiveHeight: true, // temporary option
  });
};

const initHomeCarousel = () => {
  const $curationCarousel = $('.vn-curation-carousel'),
    $controller = $('.vn-curation-carousel__controller'),
    $controllerPause = $controller.find('.slick-pause'),
    $controllerPlay = $controller.find('.slick-play'),
    CLASSNAME_PLAYED = 'vn-curation-carousel__controller--played',
    CLASSNAME_PAUSED = 'vn-curation-carousel__controller--paused';

  const SLIDE_OPT = {
    fade: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 800,
    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
    dotsClass: 'vn-curation-carousel__dots',
    appendDots: '.vn-curation-carousel__func',
    appendArrows: $controller,
  };

  $curationCarousel
    .on('init', () => {
      $controller.addClass(CLASSNAME_PLAYED);
    })
    .slick(SLIDE_OPT);

  $controllerPlay.on('click', () => {
    $controller.removeClass(CLASSNAME_PAUSED).addClass(CLASSNAME_PLAYED);

    $curationCarousel.slick('slickPlay');
    $controllerPause.focus();
  });

  $controllerPause.on('click', () => {
    $controller.removeClass(CLASSNAME_PLAYED).addClass(CLASSNAME_PAUSED);

    $curationCarousel.slick('slickPause');
    $controllerPlay.focus();
  });
};

export const initCarousel = () => {
  $(function () {
    const $curationCarousel = $('.vn-curation-carousel');
    const $bannerCarousel = $('.vn-banner-carousel');

    $curationCarousel && initHomeCarousel();
    $bannerCarousel && initCommonCarousel($bannerCarousel);
  });
};
